export const mapState = (state: string): string => {
  switch (state) {
    case 'ACTIVE':
      return 'Aktivní';
    case 'INACTIVE':
      return 'Neaktivní';
    case 'QUEUED':
      return 'Ve frontě';
    case 'WAITING':
      return 'Čekající';
    case 'CANCELLED':
      return 'Zrušený';
    default:
      return 'Neznámý';
  }
};
